import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaSalvar(solicitacao) {
  delete solicitacao.contaCredito;
  delete solicitacao.contaDebito;
  delete solicitacao.solicitante;
  delete solicitacao.liberadoPor;
  delete solicitacao.protocolo;
  delete solicitacao.solTransRateioCredito.projeto;
  delete solicitacao.solTransRateioCredito.projetoMetaEtapa;
  delete solicitacao.solTransRateioCredito.rubrica;
  delete solicitacao.solTransRateioCredito.subrubrica;
  delete solicitacao.solTransRateioDebito.projeto;
  delete solicitacao.solTransRateioDebito.projetoMetaEtapa;
  delete solicitacao.solTransRateioDebito.rubrica;
  delete solicitacao.solTransRateioDebito.subrubrica;

  if (solicitacao.dataTransferencia) {
    solicitacao.dataTransferencia = await formatarData.paraNumero(solicitacao.dataTransferencia);
  }

  return solicitacao;
}

function normalizarParaVisualizar(solicitacao) {
  solicitacao.valorTransferencia = converterMoeda.paraReal(solicitacao.valorTransferencia);

  solicitacao.solTransRateioCredito.map(rateio => {
    rateio.valorRateio = converterMoeda.paraReal(rateio.valorRateio);
  });

  solicitacao.solTransRateioDebito.map(rateio => {
    rateio.valorRateio = converterMoeda.paraReal(rateio.valorRateio);
  });

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaotransferencia', { params: parametros });
  },
  adicionar: async (solicitacao, arquivos) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;
    
    solicitacao = await converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaotransferencia', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, arquivos, id) => {
    solicitacao = await normalizarParaSalvar(solicitacao, id);
    solicitacao.arquivos = arquivos;
    
    solicitacao = await converterObjetoFormData(solicitacao);
    
    return Vue.http.put(`/api/solicitacaotransferencia/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaotransferencia/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaotransferencia/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaotransferencia/${id}/cancelar`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaotransferencia/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaotransferencia/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  contas: function (tipo) {
    return Vue.http.get(`/api/solicitacaotransferencia/${tipo}/contas`).then(response => response.data);
  },
  projetos: function (idConta, tipo) {
    return Vue.http.get(`/api/solicitacaotransferencia/${idConta}/projetos/${tipo}/tipo`).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-transferencia/servico.js